import * as React from "react";
import parse, { domToReact } from "html-react-parser";
import { UitkList, UitkListItem } from "../uitk-react-list/index.js";
import { UitkSpacing, UitkSpacingHr } from "../uitk-react-spacing/index.js";
import { UitkHeading, UitkParagraph, UitkText } from "../uitk-react-text/index.js";
import { DisallowedElementsArray } from "./types.js";
export function UitkUnformattedHtml({
  elementsToReplace = UitkUnformattedHtmlReplaceDefaults,
  htmlToParse,
  plainTextElement: PlainTextElement = (props) => /* @__PURE__ */ React.createElement(UitkText, { size: 300 }, props.children || null),
  children
}) {
  const parseOptions = {
    replace: (domNode) => {
      const { children: children2 } = domNode;
      const generateChildren = () => /* @__PURE__ */ React.createElement(React.Fragment, null, domToReact(children2, parseOptions));
      if (elementsToReplace?.hasOwnProperty(domNode.name)) {
        const Component = elementsToReplace[domNode.name];
        return /* @__PURE__ */ React.createElement(Component, null, generateChildren());
      }
      if (DisallowedElementsArray.includes(domNode.name)) {
        return /* @__PURE__ */ React.createElement(React.Fragment, null);
      }
    }
  };
  if (htmlToParse) {
    const elements = parse(htmlToParse, parseOptions);
    return /* @__PURE__ */ React.createElement(React.Fragment, null, PlainTextElement && elements === htmlToParse ? /* @__PURE__ */ React.createElement(PlainTextElement, null, elements) : elements);
  } else if (children) {
    return /* @__PURE__ */ React.createElement("div", null, children);
  } else {
    return null;
  }
}
;
const headingStyle = (curriedProps) => {
  return (props) => /* @__PURE__ */ React.createElement(UitkSpacing, { margin: { blockstart: "four" } }, /* @__PURE__ */ React.createElement(UitkHeading, { ...props, ...curriedProps }, props.children || null));
};
export const UitkUnformattedHtmlReplaceDefaults = {
  h1: headingStyle({ size: 1, tag: "h1" }),
  h2: headingStyle({ size: 2, tag: "h2" }),
  h3: headingStyle({ size: 3, tag: "h3" }),
  h4: headingStyle({ size: 4, tag: "h4" }),
  h5: headingStyle({ size: 5, tag: "h5" }),
  h6: headingStyle({ size: 6, tag: "h6" }),
  hr: () => /* @__PURE__ */ React.createElement(UitkSpacingHr, null),
  li: (props) => /* @__PURE__ */ React.createElement(UitkListItem, { ...props }, props.children || null),
  ol: (props) => /* @__PURE__ */ React.createElement(UitkSpacing, { margin: { blockstart: "two" } }, /* @__PURE__ */ React.createElement(UitkList, { ...props, type: "ordered" }, props.children || null)),
  p: (props) => /* @__PURE__ */ React.createElement(UitkParagraph, { ...props, size: 2 }, props.children || null),
  ul: (props) => /* @__PURE__ */ React.createElement(UitkSpacing, { margin: { blockstart: "two" } }, /* @__PURE__ */ React.createElement(UitkList, { ...props }, props.children || null))
};
